import { useShallow } from 'zustand/react/shallow';
import storage from '../../../../../../hooks/useStorage/useStorage';
import LangEnum from '../../../../../../lang/LangEnum';
import useProductDetailsStore from '../../../../../../stores/ProductDetails/productDetails.store';
import { ProductDetailsTestIds } from '../../../../../../utils/testIds/productDetails.testIds';
import { AllColorsFilterProps } from '../ProductFilters/types/productFilters.types';
import ProductFilterToggleButton from './button/components/ProductFilterToggleButton';

const AllColorsFilter = ({ productColorId, disabled }: AllColorsFilterProps) => {
  const {
    productGridParams,
    productDetailsModalState,
    removeCopiedGrid,
    setMediaProductColorId,
    setProductDetailsModalState,
    handleChangeProductGridParams,
  } = useProductDetailsStore(
    useShallow((state) => ({
      productDetailsModalState: state.productDetailsModalState,
      productGridParams: state.productGridParams,
      setProductDetailsModalState: state.setProductDetailsModalState,
      setMediaProductColorId: state.setMediaProductColorId,
      removeCopiedGrid: state.removeCopiedGrid,
      handleChangeProductGridParams: state.handleChangeProductGridParams,
    })),
  );

  const allColorsSelected = !productGridParams.productColorId;

  const handleRemoveAllColors = () => {
    removeCopiedGrid();
    setProductDetailsModalState({
      isOpen: true,
      productColorId,
      productId: productDetailsModalState.productId,
      disableGrid: productDetailsModalState?.disableGrid,
      disablePrice: productDetailsModalState?.disablePrice,
    });
    handleChangeProductGridParams({
      ...productGridParams,
      productColorId,
    });

    storage.setProductDetailsFilter(storage.getSessionId() as string, {
      isAllColorsFilterSelected: false,
    });
  };

  const handleToggleAllColors = () => {
    if (allColorsSelected) {
      return handleRemoveAllColors();
    }

    removeCopiedGrid();
    setMediaProductColorId(undefined);
    handleChangeProductGridParams({
      ...productGridParams,
      productColorId: undefined,
    });

    storage.setProductDetailsFilter(storage.getSessionId() as string, {
      isAllColorsFilterSelected: true,
    });
  };

  return (
    <ProductFilterToggleButton
      value="allColors"
      selected={allColorsSelected}
      disabled={disabled}
      onClick={handleToggleAllColors}
      label={LangEnum.PRODUCT_DETAILS_COLOR_FILTER_LABEL}
      testId={ProductDetailsTestIds.ALL_COLORS_FILTER}
    />
  );
};

export default AllColorsFilter;
